<template>
    <div class="auth_in">
        <template v-if="envName === 'stater'">
            <img src="@/assets/stater/images/logo.svg" alt="" />
        </template>  
        <template v-else>
            <img src="@/assets/images/auth_card.png" alt="" />
        </template>

        <div class="title">{{text('wallet.auth.title')}}</div>
        <router-link :to="{ name: 'Register' }" class="main_btn">{{text('wallet.auth.register')}}</router-link>
        <div class="text">
            <span>{{text('wallet.auth.already_have')}}</span>
            <router-link :to="{name: 'LogIn'}" class="link_text">{{text('wallet.auth.login')}}</router-link>
        </div>

        <StaterFooter v-if="envName === 'stater'" />
        <GrokPolicy v-if="envName === 'grok'" />

    </div>
</template>

<script>
import StaterFooter from '@/components/StaterFooter.vue'
import GrokPolicy from '@/components/GrokPolicy.vue'
export default {
    name: "Auth",
    components: {
        StaterFooter,
        GrokPolicy
    }
}
</script>

<style>

</style>